var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoryRedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23549 2.9572C3.60433 1.30942 2.30689 2.11496 1.62887 3.05937C1.39781 3.3812 1.33293 3.78416 1.34618 4.18011C1.38822 5.43623 1.37045 7.15984 1.17746 12.3514C1.00251 17.0577 3.05483 18.9862 4.73087 19.9466C5.49642 20.3853 6.05457 21.1285 6.11147 22.0089L6.38974 26.3147C6.47043 27.5632 7.50654 28.5345 8.75757 28.5345H20.102C21.4124 28.5345 22.4727 27.4703 22.5698 26.1635C22.7037 24.3611 22.9186 22.9515 22.7962 22.0515C22.7671 21.8376 22.7354 21.6233 22.7238 21.4077C22.5363 17.9359 19.3431 17.524 17.8814 17.446H12.7287H10.41C6.76014 17.8145 5.91066 13.8795 5.70591 12.3514L5.7671 4.39659C5.77119 3.86582 5.60891 3.33442 5.23549 2.9572Z",
    stroke: "#AF3208",
    strokeWidth: 2.23854
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0158,
    cy: 9.44643,
    r: 4.73732,
    stroke: "#AF3208",
    strokeWidth: 2.23854
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryRedIcon);
export default __webpack_public_path__ + "static/media/storyRedIcon.80c51ba1633480c238902b28c7397746.svg";
export { ForwardRef as ReactComponent };